import { cTopSearch } from "../../../components/header/top-search/top-search";
import { cUtil }      from "../../../functions/util";

export class cSearch {

  container      = document.querySelector('.c-search')      as HTMLElement;
  prodData       = document.querySelector('.c-search-data') as HTMLScriptElement;
  label_name     = document.createElement('label');
  input_name     = document.createElement('input');
  label_cat1     = document.createElement('label');
  select_cat1    = document.createElement('select');
  // label_cat2     = document.createElement('label');
  // select_cat2    = document.createElement('select');
  // label_cat3     = document.createElement('label');
  // select_cat3    = document.createElement('select');
  label_cat5     = document.createElement('label');
  select_cat5    = document.createElement('select');
  label_rel3     = document.createElement('label');
  select_rel3    = document.createElement('select');
  label_time     = document.createElement('label');
  select_time    = document.createElement('select');
  label_origin   = document.createElement('label');
  select_origin  = document.createElement('select');
  label_label    = document.createElement('label');
  select_label   = document.createElement('select');
  button_search  = document.createElement('button'); 
  div_container  = document.createElement('div');
  div_products   = document.createElement('div');
  div_lists      = document.createElement('div');

  products: SearchItemExt[];
  links   : HTMLAnchorElement[] = [];
  lists   : HTMLAnchorElement[] = [];

  cat1 = '';
  // cat2 = '';
  // cat3 = '';
  cat5 = '';
  rel3 = '';
  labl = '';
  time = '';
  orig = '';


  constructor() {
    this.products = JSON.parse(this.prodData.innerText) as SearchItemExt[];
    
    // ---- Structure ----
    this.container.append(this.label_name);
    this.container.append(this.input_name);
    this.container.append(this.label_cat1);
    this.container.append(this.select_cat1);
    // this.container.append(this.label_cat2);
    // this.container.append(this.select_cat2);
    // this.container.append(this.label_cat3);
    // this.container.append(this.select_cat3);
    this.container.append(this.label_cat5);
    this.container.append(this.select_cat5);
    this.container.append(this.label_rel3);
    this.container.append(this.select_rel3);
    this.container.append(this.label_time);
    this.container.append(this.select_time);
    this.container.append(this.label_origin);
    this.container.append(this.select_origin);
    this.container.append(this.label_label);
    this.container.append(this.select_label);
    this.container.append(this.button_search);
    this.container.append(this.div_container);
      this.div_container.append(this.div_products);
      this.div_container.append(this.div_lists);

    // ---- Texts ----
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    this.label_name.innerText      = __('Name'            , 'custom');
    this.label_cat1.innerText      = __('Kategorien'      , 'custom');
    // this.label_cat2.innerText      = __('Gattung'         , 'custom');
    // this.label_cat3.innerText      = __('Teilstück'       , 'custom');
    this.label_cat5.innerText      = __('Verpackungsart'  , 'custom');
    this.label_rel3.innerText      = __('Kühlung'         , 'custom');
    this.label_time.innerText      = __('Lieferzeit'      , 'custom');
    this.label_origin.innerText    = __('Herkunftsland'   , 'custom');
    this.label_label.innerText     = __('Label'           , 'custom');
    this.button_search.innerText   = __('Anzeigen'        , 'custom');

    // ---- Label Ids ----
    cUtil.labelIds(this.label_name,   this.input_name);
    cUtil.labelIds(this.label_cat1,   this.select_cat1);
    // cUtil.labelIds(this.label_cat2,   this.select_cat2);
    // cUtil.labelIds(this.label_cat3,   this.select_cat3);
    cUtil.labelIds(this.label_cat5,   this.select_cat5);
    cUtil.labelIds(this.label_rel3,   this.select_rel3);
    cUtil.labelIds(this.label_time,   this.select_time);
    cUtil.labelIds(this.label_origin, this.select_origin);
    cUtil.labelIds(this.label_label,  this.select_label);

    // ---- css ----
    this.css('label_name');
    this.css('input_name');
    this.css('label_cat1');
    this.css('select_cat1');
    // this.css('label_cat2');
    // this.css('select_cat2');
    // this.css('label_cat3');
    // this.css('select_cat3');
    this.css('label_cat5');
    this.css('select_cat5');
    this.css('label_rel3');
    this.css('select_rel3');
    this.css('label_time');
    this.css('select_time');
    this.css('label_origin');
    this.css('select_origin');
    this.css('label_label');
    this.css('select_label');

     // ---- Other ----
     this.input_name.type    = 'text';
     this.button_search.type = 'button';
     this.button_search.classList.add('c-button');

     // ---- Init ----
     const urlParams = new URLSearchParams(window.location.search)
     this.cat1             = urlParams.get('cat1') ?? '';
    //  this.cat2             = urlParams.get('cat2') ?? '';
    //  this.cat3             = urlParams.get('cat3') ?? '';
     this.cat5             = urlParams.get('cat5') ?? '';
     this.rel3             = urlParams.get('rel3') ?? '';
     this.labl             = urlParams.get('labl') ?? '';
     this.time             = urlParams.get('time') ?? '';
     this.orig             = urlParams.get('orig') ?? '';
     this.input_name.value = urlParams.get('s')    ?? '';     
     this.allOptionsInit();

     // ---- Events ----
    this.select_cat1.addEventListener('change', () => {
      this.cat1 = this.select_cat1.value;
      this.allOptions();
    });
    // this.select_cat2.addEventListener('change', () => {
    //   this.cat2 = this.select_cat2.value;
    //   this.allOptions();
    // });
    // this.select_cat3.addEventListener('change', () => {
    //   this.cat3 = this.select_cat3.value;
    //   this.allOptions();
    // });
    this.select_cat5.addEventListener('change', () => {
      this.cat5 = this.select_cat5.value;
      this.allOptions();
    });
    this.select_rel3.addEventListener('change', () => {
      this.rel3 = this.select_rel3.value;
      this.allOptions();
    });
    this.select_label.addEventListener('change', () => {
      this.labl = this.select_label.value;
      this.allOptions();
    });
    this.select_time.addEventListener('change', () => {
      this.time = this.select_time.value;
      this.allOptions();
    });
    this.select_origin.addEventListener('change', () => {
      this.orig = this.select_origin.value;
      this.allOptions();
    });
    this.input_name.addEventListener('keyup', () => {
      this.filterName();
    });

    this.button_search.addEventListener('click', () => {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('cat1' , this.select_cat1.value);
      // urlParams.set('cat2' , this.select_cat2.value);
      // urlParams.set('cat3' , this.select_cat3.value);
      urlParams.set('cat5' , this.select_cat5.value);
      urlParams.set('rel3' , this.select_rel3.value);
      urlParams.set('labl' , this.select_label.value);
      urlParams.set('time' , this.select_time.value);
      urlParams.set('orig' , this.select_origin.value);
      urlParams.set('s'    , this.input_name.value);
      // const url = window.location.pathname +'?' + urlParams.toString();
      const url = '/shop?' + urlParams.toString();
      window.location.href = url;
    });
  }

  allOptionsInit() {
    this.cat1Options();
    // this.cat2Options();
    // this.cat3Options();
    this.cat5Options();
    this.rel3Options();
    this.timeOptions();
    this.originOptions();
    this.labelOptions();
  }

  allOptions() {
    this.cat1Options();
    // this.cat2Options();
    // this.cat3Options();
    this.cat5Options();
    this.rel3Options();
    this.timeOptions();
    this.originOptions();
    this.labelOptions();
    this.filterName();
  }

  filterName() {
    const input         = this.input_name.value;
    const allProducts   = this.products;
    const productElm    = this.div_products;
    const listElm       = this.div_lists;

    cTopSearch.filterNameBase(input, allProducts, productElm, listElm, this);
  }

  cat1Options() {
    this.select_cat1.innerHTML = '';

    const selectedProds = 
      this.selectedProducts('cat1')
      .filter(prod => prod.cat_1 !== '')
      .map(prod => prod.cat_1);

    this.createOptions(selectedProds, this.select_cat1, this.cat1, 'cat1');
  }

  // cat2Options() {
  //   this.select_cat2.innerHTML = '';

  //   const selectedProds = 
  //     this.selectedProducts('cat2')
  //     .filter(prod => prod.cat_2 !== '')
  //     .map(prod => prod.cat_2);

  //   this.createOptions(selectedProds, this.select_cat2, this.cat2, 'cat2');
  // }

  // cat3Options() {
  //   this.select_cat3.innerHTML = '';

  //   const selectedProds = 
  //     this.selectedProducts('cat3')
  //     .filter(prod => prod.cat_3 !== '')
  //     .map(prod => prod.cat_3);

  //   this.createOptions(selectedProds, this.select_cat3, this.cat3, 'cat3');
  // }

  cat5Options() {
    this.select_cat5.innerHTML = '';

    const selectedProds = 
      this.selectedProducts('cat5')
      .filter(prod => prod.cat_5 !== '')
      .map(prod => prod.cat_5);

    this.createOptions(selectedProds, this.select_cat5, this.cat5, 'cat5');
  }

  rel3Options() {
    this.select_rel3.innerHTML = '';

    const selectedProds = 
      this.selectedProducts('rel3')
      .filter(prod => prod.rel_3_code !== '')
      .map(prod => prod.rel_3_code);

    this.createOptions(selectedProds, this.select_rel3, this.rel3, 'rel3');
  }

  timeOptions() {
    this.select_time.innerHTML = '';

    const selectedProds = 
      this.selectedProducts('time')
      .filter(prod => prod.delivery_time !== '')
      .map(prod => prod.delivery_time);

    this.createOptions(selectedProds, this.select_time, this.time, 'time');
  }

  originOptions() {
    this.select_origin.innerHTML = '';

    const selectedProds = 
      this.selectedProducts('orig')
      .filter(prod => prod.origin_code !== '')
      .map(prod => prod.origin_code);

    this.createOptionsOrigin(selectedProds, this.select_origin, this.orig, 'orig');
  }

  labelOptions() {
    this.select_label.innerHTML = '';

    const selectedProds = 
      this.selectedProducts('labl')
      .filter(prod => prod.label_code !== '')
      .map(prod => prod.label_code);

    this.createOptions(selectedProds, this.select_label, this.labl, 'labl');
  }

  selectedProducts(code : 'cat1'|'cat2'|'cat3'|'cat5'|'rel3'|'time'|'orig'|'labl'|'name'): SearchItemExt[] {

    const cat1 = code === 'cat1' ? '' : this.cat1;
    // const cat2 = code === 'cat2' ? '' : this.cat2;
    // const cat3 = code === 'cat3' ? '' : this.cat3;
    const cat5 = code === 'cat5' ? '' : this.cat5;
    const rel3 = code === 'rel3' ? '' : this.rel3;
    const time = code === 'time' ? '' : this.time;
    const orig = code === 'orig' ? '' : this.orig;
    const labl = code === 'labl' ? '' : this.labl;

    const selectedProds = 
      this.products
      .filter(prod => cat1   === '' || prod.cat_1         === cat1)
      // .filter(prod => cat2   === '' || prod.cat_2         === cat2)
      // .filter(prod => cat3   === '' || prod.cat_3         === cat3)
      .filter(prod => cat5   === '' || prod.cat_5         === cat5)
      .filter(prod => rel3   === '' || prod.rel_3_code    === rel3)
      .filter(prod => time   === '' || prod.delivery_time === time)
      .filter(prod => orig   === '' || prod.origin_code   === orig)
      .filter(prod => labl   === '' || prod.label_code    === labl);

    return selectedProds;
  }

  createOptions(values: string[], parent: HTMLSelectElement, currentValue: string, domain: string) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const distinct =
      [...new Set(values)]
      .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

    const option_elm     = document.createElement('option');
    option_elm.value     = '';
    option_elm.selected  = false;
    option_elm.innerText = '— ' + __('Alle', 'custom') + ' —'; 
    parent.append(option_elm);

    for(let optionValue of distinct) {
      const option_elm     = document.createElement('option');
      option_elm.value     = optionValue;
      option_elm.selected  = optionValue === currentValue;
      option_elm.innerText = this.codes(optionValue, domain);  
      parent.append(option_elm);
    }
  }

  createOptionsOrigin(values: string[], parent: HTMLSelectElement, currentValue: string, domain: string) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const count = 
      values
      .reduce((acc, val) => {
        let sum = acc.get(val) ?? 0;
        acc.set(val, ++sum);
        return acc;
      }, new Map<string, number>());

    const distinct =
      Array.from(count)
      .sort((a, b) => b[1] - a[1])
      .map(a => a[0]);

    // const distinct =
    //   [...new Set(values)]
    //   .sort((a, b) => (count.get(a) ?? 0) - (count.get(b) ?? 0));

    const option_elm     = document.createElement('option');
    option_elm.value     = '';
    option_elm.selected  = false;
    option_elm.innerText = '— ' + __('Alle', 'custom') + ' —'; 
    parent.append(option_elm);

    for(let optionValue of distinct) {
      const option_elm     = document.createElement('option');
      option_elm.value     = optionValue;
      option_elm.selected  = optionValue === currentValue;
      option_elm.innerText = this.codes(optionValue, domain);  
      parent.append(option_elm);
    }
  }

  codes(code: string, domain: string) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const string = [
      __('Rind'                  , 'custom'),
      __('Huft'                  , 'custom'),
      __('Schwein'               , 'custom'),
      __('Kotlett'               , 'custom'),
      __('Fisch'                 , 'custom'),
      __('Filet'                 , 'custom'),
    ];
    if (domain === 'labl') {
      code = code.replace('IM',              __('International'     ,      'custom'));
      code = code.replace('IP',              __('IP Suisse'         ,      'custom'));
    }
    return code;
  }

  css<K extends keyof cSearch>(propertyName: K): void {
    const property = this[propertyName];
    if (! (property instanceof HTMLElement)) return;
    property.classList.add(propertyName);
    property.style.gridArea = propertyName;
  }
}